import React from 'react'

import { toggle } from '~/utils/array'
import { getRangeInputValues } from '~/utils/filtering'
import { track } from '~/utils/tracking'

import Facet from './facet'

const RangeFacetsVariant = ({
  data,
  ranges,
  formatLabelFn,
  shouldShowUnit = true,
  selectedFiltersByFilterGroup = [],
  onChangeFilterGroup,
  overrideUnit,
  facetTitle,
  isLastChild = false
}) => {
  const { unit } = data
  const unitsToDisplay = overrideUnit || unit

  const handleOnChange = (event, rangeFrom, rangeTo) => {
    const value = event.target.value
    track(`Filter - ${facetTitle}`, formatLabelFn(rangeFrom, rangeTo) + (shouldShowUnit && unitsToDisplay), value)
    const selectedRanges = toggle(selectedFiltersByFilterGroup.map(JSON.stringify), value)
    onChangeFilterGroup(selectedRanges.map(JSON.parse))
  }

  return ranges.map((range) => {
    const { available, value, count } = getRangeInputValues(range, data)
    const { rangeFrom, rangeTo } = range
    const checked = selectedFiltersByFilterGroup.map(JSON.stringify).includes(value)

    return (
      <Facet
        key={value}
        inputName='filters[download_speeds][]'
        inputValue={value}
        inputId='checkbox--low'
        inputDisabled={!available}
        inputChecked={checked}
        inputOnChange={(event) => handleOnChange(event, rangeFrom, rangeTo)}
        labelName={formatLabelFn(rangeFrom, rangeTo)}
        labelUnit={shouldShowUnit && unitsToDisplay}
        labelCount={count}
        isLastChild={isLastChild}
      />
    )
  })
}

export default RangeFacetsVariant
